export default __webpack_public_path__ + "static/media/zarya-ult.745447cb.mp3";